export default {
  'executeProcessAction.mapping': 'Mapping',
  'executeProcessAction.addMapping': 'Add mapping',
  'executeProcessAction.noMappings':
    'No mappings yet. Add instance-name and approval/reject at minimum.',
  'executeProcessAction.requiredMissing':
    'Add mappings for instance-name and approval/reject before saving.',
  'executeProcessAction.form.valueDestination': 'Value destination',
  'executeProcessAction.form.dest.instanceName': 'Instance name',
  'executeProcessAction.form.dest.isApprovalOrReject': 'Is approval or reject',
  'executeProcessAction.form.dest.observations': 'Operation observations',
  'executeProcessAction.form.dest.formField': 'Form field',
  'executeProcessAction.form.dest.variable': 'Variable',
};
